import axios from "axios";
import { toast } from "react-toastify";

// Use this instance for all API requests
// The base URL is set from your environment variables
const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_SUPERADMIN_BASE_URL?.replace(/\/$/, ''), // Remove trailing slash
  headers: { "Content-Type": "application/json" },
  // You can add default headers or interceptors here if needed
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    if (!config.headers.Authorization && token) {
      config.headers.Authorization = `Bearer ${token.replace(/"/g, "")}`;
    }
    

    
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    // Don't redirect on login endpoint errors - let the login component handle them
    if (
      (error.response?.data?.status === 401 ||
        error.response?.data?.status === 403) &&
      !error.config.url?.includes("secure-auth/login")
    ) {
      console.log("Unauthorized! Dispatching logout...");
      localStorage.clear();
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default axiosInstance; 